import type { ReactElement } from 'react';
import { PageHeader } from '../components/PageHeader.js';
import { EmptyState } from '../components/EmptyState.js';

export function AuditPage(): ReactElement {
  return (
    <>
      <PageHeader
        title="Audit log"
        description="Who changed what, and when. Recorded for every admin route and every authentication event."
      />
      <EmptyState
        milestone="M4"
        title="Recording starts in M1; this reader arrives in M4"
        description="The API writes an audit entry for every admin action from the moment the routes exist, including sign-ins, failed code attempts and device pairings. This page is where those entries become searchable."
        points={[
          'Actor, action, target and the before-and-after of each change',
          'Authentication events: codes requested, verified and refused',
          'Pairing and un-pairing, so a device that changed hands has a trail',
          'Filter by store, by person and by date range',
        ]}
      />
    </>
  );
}
